import { Box } from '@mui/system';
import React, { FC } from 'react';
import { IProps } from 'types/common';
import { WizardPhase } from 'types/wizard';
import WizardTimeline from './WizardTimeline';

interface IWizardLayoutProps extends IProps {
	phase: `${WizardPhase}` | '';
}

const WizardLayout: FC<IWizardLayoutProps> = ({ children, phase }) => (
	<Box
		data-testid="wizard-layout"
		display="flex"
		flexGrow={1}
		flexDirection="column"
	>
		<Box
			display="flex"
			minHeight={{
				xs: 'auto',
				sm: 64
			}}
			data-testid="wizard-layout-timeline"
			p={{
				xs: 0,
				sm: 1
			}}
			pr={5}
		>
			<WizardTimeline phase={phase} />
		</Box>
		{children}
	</Box>
);

export default WizardLayout;
